// Sonave – skin concerns: reveals the ring when it scrolls into view, then
// highlights one concern at a time on desktop. Hovering a concern takes over.
if (!customElements.get('glow-concerns')) {
  customElements.define(
    'glow-concerns',
    class GlowConcerns extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-concern]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.index = -1;
        this.hovering = false;

        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        if (!('IntersectionObserver' in window) || designMode || this.reduceMotion.matches) {
          this.classList.add('is-revealed');
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.inView = entry.isIntersecting;
                if (entry.isIntersecting && !this.classList.contains('is-revealed')) {
                  this.classList.add('is-revealed');
                  // Start highlighting once the bubbles have landed
                  this.startTimer = setTimeout(() => this.start(), 2200);
                  return;
                }
                this.inView ? this.start() : this.stop();
              });
            },
            { threshold: 0.3 }
          );
          this.observer.observe(this);
        }

        this.items.forEach((item, i) => {
          item.addEventListener('mouseenter', () => {
            this.hovering = true;
            this.stop();
            this.activate(i);
          });
          item.addEventListener('mouseleave', () => {
            this.hovering = false;
            this.start();
          });
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.startTimer);
        this.stop();
      }

      activate(i) {
        this.index = i;
        this.items.forEach((item, n) => item.classList.toggle('is-active', n === i));
      }

      start() {
        if (this.timer || this.hovering || !this.inView || this.reduceMotion.matches || !this.desktop.matches) return;
        if (!this.classList.contains('is-revealed') || this.items.length < 2) return;
        this.classList.add('is-cycling');
        this.activate((this.index + 1) % this.items.length);
        this.timer = setInterval(() => this.activate((this.index + 1) % this.items.length), 2400);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
        if (!this.hovering) {
          this.classList.remove('is-cycling');
          this.items.forEach((item) => item.classList.remove('is-active'));
        }
      }
    }
  );
}
